// Step 6.7.2 / AC171: persisted unit preference store. The Power Buyer
// Buy-by toggle was local component state and reset on every reload /
// nav-away. Zustand persist + localStorage backing makes the selection
// stick across reloads and remounts.
//
// SSR note: Zustand's persist middleware hydrates after mount, so
// the first paint will use the default ("box"); the stored value (if
// different) takes over once rehydration completes. This brief flash
// is acceptable for a 24px toggle - skipHydration would cost more
// complexity than it saves.

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type UnitChoice = "bunch" | "box";

type PreferencesStore = {
  unitPreference: UnitChoice;
  setUnitPreference: (unit: UnitChoice) => void;
};

const STORAGE_KEY = "mag-portal-unit-pref";

export const usePreferences = create<PreferencesStore>()(
  persist(
    (set) => ({
      unitPreference: "box",
      setUnitPreference: (unitPreference) => set({ unitPreference }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

// Used by sign-out to wipe persisted preferences.
export function clearPersistedPreferences(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
